

































































































import { Component, Prop } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import ListUtils from '@/lib/listUtils';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import ProductSubType from '@/models/Products/ProductSubType';
import PeriodType from "@/models/Shared/PeriodType";

@Component({ name: 'DepositPaymentOrderSettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({ required: true })
    isCreate: boolean

    @Prop({ required: false })
    productSubType: ProductSubType

    get productVM() {
        if (this.isCreate) {
            if (this.productSubType === ProductSubType.DepositCurrentAccount || this.productSubType === ProductSubType.DepositSavingsAccount || this.productSubType === ProductSubType.DepositFixedTerm) {
                ProductWizardModule.createProductViewModel.depositPaymentOrderSettingsAvailable = true;
            }
            else if (this.productSubType === ProductSubType.DepositNoticeAccount) {
                ProductWizardModule.createProductViewModel.depositPaymentOrderSettingsAvailable = true;
                ProductWizardModule.createProductViewModel.depositPaymentOrderSettings.noticePeriodEnabled = true;
                ProductWizardModule.createProductViewModel.depositPaymentOrderSettings.noticePeriodType = PeriodType.Day;
                ProductWizardModule.createProductViewModel.depositPaymentOrderSettings.noticePeriodValue = 95;
            }
            return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

}
